import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigModel, ConfigRTCModel, MqttSettingsModel, CsvHeaderModel } from 'src/app/Model/IConfiguration';
import { AuthService } from 'src/app/service/auth.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { MQTTOperation } from 'src/app/Service/mqttoperation.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { DatePipe, formatDate } from '@angular/common';
@Component({
  selector: 'app-config-parameter',
  templateUrl: './gsmconfig.html'
})
export class GSMConfigComponent implements OnInit {

  // Property Declaration
  IsreadOnly: boolean = false;
  DisplayButton: boolean = false;
  RoleName: string = '';
  gsmconfigForm: FormGroup;
  RTCconfigForm: FormGroup;
  MqttSettingsForm: FormGroup;
  EthernetSettingsForm: any = FormGroup;
  Config: ConfigModel = new ConfigModel();
  RTCConfig: ConfigRTCModel = new ConfigRTCModel();
  MqttSettings: MqttSettingsModel = new MqttSettingsModel();
  errorMsg: string = '';
  successMsg: string = '';
  UserPrefData: any[] = [];
  displayMessage1: { [key: string]: string } = {};
  displayMessage2: { [key: string]: string } = {};
  displayMessage3: { [key: string]: string } = {};
  displayMessage4: { [key: string]: string } = {};
  validationMessages1!: { [key: string]: { [key: string]: string } };
  validationMessages2!: { [key: string]: { [key: string]: string } };
  validationMessages3!: { [key: string]: { [key: string]: string } };
  validationMessages4!: { [key: string]: { [key: string]: string } };
  genericValidator1!: GenericValidator;
  genericValidator2!: GenericValidator;
  genericValidator3!: GenericValidator;
  genericValidator4!: GenericValidator;
  MasterSlave: number = 0;
  DropDownList: any;
  KeyID: string = '';
  DeviceTypeID: number;
  MeterId: number;
  GSMConfigFormGetData: any;
  GSMConfigFormSaveData: any;
  EthernetSettingsFormSaveData: any
  UserName: string = '';
  EnergyMeterdata: any;
  DeviceTypeList: any = [];
  BaudrateList: any = [];
  ParityList: any = [];
  APNList: any = [];
  DataLogList: any = [];
  SMSModeList: any = [];
  DataPostProtocolList: any = [];
  HttpAuthList: any = [];
  DataPostTypeList: any = [];
  JSONdatatypeList: any = [];
  AsciiStringTypeList: any = [];
  MqttConnectionCheckList: any = [];
  AnalogScalingDecimalPointList: any = []
  DataReadTypeList: any = [];
  DataLogSelectionList: any = [];
  minSlID: number = 0;
  maxSlave: number = 16;
  minSlave: number = 0;
  maxSlID: number = 0;
  minInTime: number = 0;
  maxInTime: number = 0;
  minPORT: number = 0;
  maxPORT: number = 0;
  minTimeZone: number = 0;
  maxTimeZone: number = 0;
  InTimeMessage: string = '';
  PORTMessage: string = '';
  TimeZoneMessage: string = '';
  SlaveMessage: string = '';
  SlaveValMessage: string = '';
  DeviceProtocolList: any[] = [];
  DeviceData: any;
  RTCData: any;
  MQTData: any;
  EthernetTcpSettingsData: any;
  MQTTPORTMessage: string = '';
  IsRTCChange: boolean = true;
  isRTCSaved: boolean = false;
  IsGSMChange: boolean = true;
  isGSMSaved: boolean = false;
  tabName: string = '';
  deviceName: string = '';
  encapsulation: ViewEncapsulation.None;
  CompanyCode = localStorage.getItem('CompanyCode');
  RTCData1: any = [];
  SettingsData: any = [];
  resetdevice: boolean = false
  getdatevar: boolean = false;
  showvalue: any = false
  IsEthernetChange: any;
  isEthernetSaved: any;
  Ethernetdata: any;
  getkid: any;
  AnalogscalingdecimalpointList: any;
  EthernetHTTPPostCheckList: any = [];
  EthernetHTTPGetCheckList: any = [];
  SerialDataBitsList: any = [];
  constructor(public datepipe: DatePipe, private GSMConfigService: GSMConfigurationService, private authService: AuthService, private form: FormBuilder, private dialog: MatDialog, private mqttoperation: MQTTOperation, public dialogRef: MatDialogRef<GSMConfigComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;

    if (data && data.GSMConfigAllData.DeviceTypeID) {
      this.DeviceTypeID = this.data.GSMConfigAllData.DeviceTypeID;
    }

    if (data && data.GSMConfigAllData.DeviceRTCData !== null) {
      this.RTCData = this.data.GSMConfigAllData.DeviceRTCData;
      this.RTCData1 = this.RTCData;
    }

    if (data && data.GSMConfigAllData.DeviceGSMData !== null) {
      this.DeviceData = this.data.GSMConfigAllData.DeviceGSMData;
      this.GSMConfigFormSaveData = this.DeviceData;
    }

    if (data && data.GSMConfigAllData.DeviceMQTData !== null) {
      this.MQTData = this.data.GSMConfigAllData.DeviceMQTData;
      this.SettingsData = this.MQTData;
    }

    if (data && data.GSMConfigAllData.DeviceEthernetTcpSettingsData !== null) {
      this.Ethernetdata = this.data.GSMConfigAllData.DeviceEthernetTcpSettingsData;
      this.EthernetSettingsFormSaveData = this.Ethernetdata;
    }
    if (data && data.GSMConfigAllData.DeviceName !== null) {
      this.deviceName = data.GSMConfigAllData.DeviceName;
    }

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages1 = resp.GSMConfigForm;
      this.genericValidator1 = new GenericValidator(this.validationMessages1);
    });

    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages2 = resp.RTCconfigForm;
      this.genericValidator2 = new GenericValidator(this.validationMessages2);
    });

    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages3 = resp.MqttSettingsForm;
      this.genericValidator3 = new GenericValidator(this.validationMessages3);
    });
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages4 = resp.EthernetSettingsForm;
      this.genericValidator4 = new GenericValidator(this.validationMessages4);
    });
  }

  // call on init
  ngOnInit(): void {

    this.tabName = 'Configuration';

    this.UserName = localStorage.getItem('UserName');
    // CONFIGURATION PAGE PARAMETERS
    this.gsmconfigForm = this.form.group({
      DeviceTypeID: [],
      dtype: ['0', [Validators.required]],
      Maxslav: ['10', [Validators.required]],
      MaxAnalogDevice: ['8', [Validators.required]],
      AnalogScalingDecimalPoint: ['', [Validators.required]],
      Slvid: [1, [Validators.required]],
      brate: ['0', [Validators.required]],
      prty: ['0', [Validators.required]],
      intm: [30, [Validators.required]],
      apn: ['0', [Validators.required]],
      URL: ['http://rmsmongoservice.rms-samyak.in/DeviceDataReader/AddDeviceData', [Validators.required]],
      port: ['65335', [Validators.required]],
      kid: [this.deviceName, [Validators.required]],
      FTPUsername: ['samyak', [Validators.required]],
      FTPPassword: ['samyak', [Validators.required]],
      CSVFileName: ['samyak', [Validators.required]],
      dls: ['0', [Validators.required]],
      cnmp: ['2', [Validators.required]],
      strtm: ['0', [Validators.required]],
      smstm: ['0', [Validators.required]],
      dlm: ['0', [Validators.required]],
      smsmode: ['0', [Validators.required]],
      jdt: ['0', [Validators.required]],
      Server: ['rmsmongoservice.rms-samyak.in', [Validators.required]],
      Resource: ['/DeviceDataReader/AddDeviceData', [Validators.required]],
      GetServer: ['rmsmongoservice.rms-samyak.in', [Validators.required]],
      GetResource: ['/DeviceDataReader/AddDeviceData', [Validators.required]],
      PostServer: ['rmsmongoservice.rms-samyak.in', [Validators.required]],
      PostResource: ['/DeviceDataReader/AddDeviceData', [Validators.required]],
      GetPortNumber: ['8000', [Validators.required]],
      PostPortNumber: ['8000', [Validators.required]],
      EthernetHTTPGetCheck: ['0', [Validators.required]],
      EthernetHTTPPostCheck: ['0', [Validators.required]],
      DataPostType: ['1', [Validators.required]],
      DataPostProtocol: ['0', [Validators.required]],
      SerialDataBits: ['0', [Validators.required]],
      DataReadType: ['0', [Validators.required]],
      HttpAuth: ['0', [Validators.required]],
      HttpUsername: [''],
      HttpPassword: [''],
      WiFiSSID: ['', [Validators.required]],
      WiFiPassword: ['', [Validators.required]],
      MqttConnectionCheck: ['0', [Validators.required]],
      AsciiStringType: ['0', [Validators.required]],
      HttpDataPostPort: ['0', [Validators.required]],
      RelayOnTime: ['0', [Validators.required]],
      TcpDataPostPort: ['0', [Validators.required]],
      DirectoryPath: ['', [Validators.required]],

    });
    function ipValidator(): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        const ipAddress = control.value as string;
        // Regular expression to match numbers and special characters but not letters
        const pattern = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]+$/;
        if (ipAddress && !pattern.test(ipAddress)) {
          this.errorMsg = 'The IP address should not contain alphabetic characters.';
          return { 'invalidIp': true };
        }
        return null;
      };
    }
    // RTC CONFIGURATION
    this.RTCconfigForm = this.form.group({
      DeviceID: [],
      TimeZone: ['1', [Validators.required]],
      DateTime: ['', [Validators.required]]
    });
    this.EthernetSettingsForm = this.form.group({
      DeviceID: [],
      Ip: ['', [Validators.required, this.ipAddressValidator()]],
      Subnet: [''],
      Dns: ['', [Validators.required]],
      Port: ['', [Validators.required]],
      Gateway: ['', [Validators.required]],
      IpAddress: ['', [Validators.required, this.ipAddressValidator()]],
      TcpPort: ['', [Validators.required]],
    });
    // MqttSettings form
    this.MqttSettingsForm = this.form.group({
      DeviceID: [],
      protocol: ['0', [Validators.required]],
      DeviceProtocolName: [''],
      ClientName: ['samyak', [Validators.required]],
      port: ['2023', [Validators.required]],
      MqttUsername: ['samyak', [Validators.required]],
      MqttPassword: ['samyak', [Validators.required]],
      MqttPublishtopic: ['ANALYSIS', [Validators.required]],
      MqttPublishdatakey: ['ANALYSIS', [Validators.required]],
      Longitude: ['0', [Validators.required]],
      Latitude: ['0', [Validators.required]],
      MachineSRNo: ['', [Validators.required]]
    });

    if (this.tabName == 'Configuration') {
      if (this.data.GSMConfigAllData.DeviceTypeID > 0) {
        this.GetGSMConfigdata(this.DeviceTypeID);
      }
      else {
        if (this.DeviceData) {
          this.SetConfigFormData();
          this.IsGSMChange = true;
          this.isGSMSaved = false;
        }
      }
    }

    // Call service for validation on valu change
    this.gsmconfigForm.valueChanges.subscribe(val => {
      if (this.isGSMSaved == true) {
        this.IsGSMChange = true;
      }
      value => this.displayMessage1 = this.genericValidator1.processMessages(this.gsmconfigForm);
    });

    this.RTCconfigForm.valueChanges.subscribe(val => {
      if (this.isRTCSaved == true) {
        this.IsRTCChange = true;
      }
      value => this.displayMessage2 = this.genericValidator2.processMessages(this.RTCconfigForm);
    });

    this.MqttSettingsForm.valueChanges.subscribe(
      value => this.displayMessage3 = this.genericValidator3.processMessages(this.MqttSettingsForm)
    );


    this.Getdropdownlist();

    this.UserPrefData = JSON.parse(localStorage.getItem('UserPref'));

    if (this.UserPrefData) {
      this.minSlID = this.UserPrefData.filter(x => x.PrefKey == 'MinSlaveID')[0].PrefValue;
      this.maxSlID = this.UserPrefData.filter(x => x.PrefKey == 'MaxSlaveID')[0].PrefValue;
      this.minInTime = this.UserPrefData.filter(x => x.PrefKey == 'MinIntervalTime')[0].PrefValue;
      this.maxInTime = this.UserPrefData.filter(x => x.PrefKey == 'MaxIntervalTime')[0].PrefValue;
      this.minPORT = this.UserPrefData.filter(x => x.PrefKey == 'MinPORT')[0].PrefValue;
      this.maxPORT = this.UserPrefData.filter(x => x.PrefKey == 'MaxPORT')[0].PrefValue;
      this.minTimeZone = this.UserPrefData.filter(x => x.PrefKey == 'MinTimeZone')[0].PrefValue;
      this.maxTimeZone = this.UserPrefData.filter(x => x.PrefKey == 'MaxTimeZone')[0].PrefValue;
      this.minSlave = this.UserPrefData.filter(x => x.PrefKey == 'MinSlave')[0].PrefValue;
      this.maxSlave = this.CompanyCode == 'chen' ? 50 : this.UserPrefData.filter(x => x.PrefKey == 'MaxSlave')[0].PrefValue;

    }

    this.RoleName = localStorage.getItem('RoleName');
    if (this.RoleName == 'Admin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
      this.gsmconfigForm.get('dtype')?.disable();
      this.gsmconfigForm.get('brate')?.disable();
      this.gsmconfigForm.get('prty')?.disable();
      this.gsmconfigForm.get('apn')?.disable();
      this.MqttSettingsForm.get('protocol')?.disable();

    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
    }
  }
  onCNMPChange(e: any, value: string) {
    if (parseFloat(e.target.value) > 54) {
      this.gsmconfigForm.get(value)?.patchValue(54);
    } else if (parseFloat(e.target.value) < 2) {
      this.gsmconfigForm.get(value)?.patchValue(2);
    }
  }
  ipAddressValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const ipAddressRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      const valid = ipAddressRegex.test(control.value);
      return valid ? null : { 'invalidIpAddress': { value: control.value } };
    };
  }


  SetConfigFormData() {
    this.getkid = this.data.GSMConfigAllData.DeviceName
    this.gsmconfigForm.patchValue({
      kid: this.data.GSMConfigAllData.DeviceName,
      DeviceTypeID: this.DeviceData.DeviceTypeID > 0 ? this.DeviceData.DeviceTypeID : 0,
      dtype: this.DeviceData.DeviceType.toString(),
      Maxslav: this.DeviceData.MaximumSlave,
      Slvid: this.DeviceData.SlaveID.toString(),
      MaxAnalogDevice: this.DeviceData.MaxAnalogDevice.toString(),
      AnalogScalingDecimalPoint: this.DeviceData.AnalogScalingDecimalPoint.toString(),
      brate: this.DeviceData.Baudrate.toString(),
      prty: this.DeviceData.Parity.toString(),
      intm: this.DeviceData.IntervalTimer,
      apn: this.DeviceData.APN.toString(),
      URL: this.DeviceData.URL,
      port: this.DeviceData.Port,
      FTPUsername: this.DeviceData.Username,
      FTPPassword: this.DeviceData.Password,
      CSVFileName: this.DeviceData.CSVName,
      dls: this.DeviceData.DLS.toString(),
      cnmp: this.DeviceData.CNMP.toString(),
      strtm: this.DeviceData.STRTM.toString(),
      smstm: this.DeviceData.SMSTM.toString(),
      DataPostType: this.DeviceData.DataPostType.toString(),
      EthernetHTTPGetCheck: this.DeviceData.EthernetHTTPGetCheck.toString(),
      EthernetHTTPPostCheck: this.DeviceData.EthernetHTTPPostCheck.toString(),
      AsciiStringType: this.DeviceData.AsciiStringType.toString(),
      MqttConnectionCheck: this.DeviceData.MqttConnectionCheck.toString(),
      DataReadType: this.DeviceData.DataReadType.toString(),
      HttpAuth: this.DeviceData.HttpAuth.toString(),
      HttpUsername: this.DeviceData.HttpUsername,
      HttpPassword: this.DeviceData.HttpPassword,
      WiFiSSID: this.DeviceData.WiFiSSID,
      WiFiPassword: this.DeviceData.WiFiPassword,
      DataPostProtocol: this.DeviceData.DataPostProtocol.toString(),
      SerialDataBits: this.DeviceData.SerialDataBits.toString(),
      HttpDataPostPort: this.DeviceData.HttpDataPostPort,
      RelayOnTime: this.DeviceData.RelayOnTime,
      TcpDataPostPort: this.DeviceData.TcpDataPostPort,
      dlm: this.DeviceData.DLM.toString(),
      smsmode: this.DeviceData.SMS_M.toString(),
      jdt: this.DeviceData.JDT.toString(),
      Resource: this.DeviceData.Resource ? this.DeviceData.Resource.toString() : '',
      Server: this.DeviceData.Server ? this.DeviceData.Server.toString() : '',
      GetResource: this.DeviceData.GetResource ? this.DeviceData.GetResource.toString() : '',
      GetServer: this.DeviceData.GetServer ? this.DeviceData.GetServer.toString() : '',
      PostResource: this.DeviceData.PostResource ? this.DeviceData.PostResource.toString() : '',
      PostServer: this.DeviceData.PostServer ? this.DeviceData.PostServer.toString() : '',
      PostPortNumber: this.DeviceData.PostPortNumber ? this.DeviceData.PostPortNumber.toString() : '',
      GetPortNumber: this.DeviceData.GetPortNumber ? this.DeviceData.GetPortNumber.toString() : '',
      DirectoryPath: this.DeviceData.DirectoryPath
    });
    this.DeviceData.HttpAuth == 1 ? this.showvalue = true : false
    this.Ondevice(this.DeviceData.DeviceType);
  }

  SetRTCData() {
    this.getdatevar = false
    this.RTCconfigForm.patchValue({
      DeviceID: this.RTCData.DeviceID > 0 ? this.RTCData.DeviceID : 0,
      TimeZone: this.RTCData.TimeZone,
      // DateTime:this.RTCData.DateTime
    });

    this.GetDatetime();
  }
  SetEthernetData() {
    // this.getdatevar = false
    // this.EthernetSettingsForm = this.form.group({
    this.EthernetSettingsForm.patchValue({
      DeviceID: this.Ethernetdata.DeviceID > 0 ? this.Ethernetdata.DeviceID : 0,
      Ip: this.Ethernetdata.Ip,
      Subnet: this.Ethernetdata.Subnet,
      Dns: this.Ethernetdata.Dns,
      Port: this.Ethernetdata.Port,
      Gateway: this.Ethernetdata.Gateway,
      TcpPort: this.Ethernetdata.TcpPort,
      IpAddress: this.Ethernetdata.IpAddress
    });
    // this.GetDatetime();
  }
  SetMQTTSettingData() {
    this.MqttSettingsForm = this.form.group({
      DeviceID: this.MQTData.DeviceID > 0 ? this.MQTData.DeviceID : 0,
      protocol: this.MQTData.DeviceProtocol.toString(),
      ClientName: this.MQTData.ClientName,
      port: this.MQTData.Port,
      MqttUsername: this.MQTData.UserName,
      MqttPassword: this.MQTData.Password,
      MqttPublishtopic: this.MQTData.PublishTopic,
      MqttPublishdatakey: this.MQTData.PublishDataKey,
      DeviceProtocolName: this.MQTData.DeviceProtocolName,
      Longitude: this.MQTData.Longitude,
      Latitude: this.MQTData.Latitude,
      MachineSRNo: this.MQTData.MachineSRNo
    });
  }
  // Call on click Save button
  OnSubmitConfig(): void {
    let reqparam = { ...this.gsmconfigForm.value };

    if (reqparam.HttpAuth == 1 && (reqparam.HttpPassword == '' || reqparam.HttpUsername == '')) {
      this.gsmconfigForm.get('HttpUsername')?.setValidators([Validators.required]);
      this.gsmconfigForm.get('HttpPassword')?.setValidators([Validators.required]);
    } else {
      this.gsmconfigForm.get('HttpUsername')?.clearValidators();
      this.gsmconfigForm.get('HttpPassword')?.clearValidators();
    }


    if (this.gsmconfigForm.invalid) {
      this.gsmconfigForm.updateValueAndValidity();
      this.gsmconfigForm.markAllAsTouched();

      this.displayMessage1 = this.genericValidator1.processMessages(this.gsmconfigForm, true, this.validationMessages1);      
      return
    }
    this.ValidateFields('IntervalTime');
    this.ValidateFields('PORT');
    this.ValidateFields('TimeZone');
    this.ValidateFields('SlaveID');
    this.ValidateFields('Slave');

    if (this.InTimeMessage === '' && this.SlaveMessage === '' && this.PORTMessage === '' && this.MQTTPORTMessage === '' && this.TimeZoneMessage === '' && this.SlaveValMessage === '') {

      let reqparam = { ...this.gsmconfigForm.value };
      this.GSMConfigFormSaveData = {
        'DeviceTypeID': reqparam.DeviceTypeID > 0 ? reqparam.DeviceTypeID : this.DeviceTypeID > 0 ? this.DeviceTypeID : 0,
        'EnergymeterID': this.MeterId,
        'DeviceType': reqparam.dtype,
        'MaximumSlave': reqparam.Maxslav,
        'AnalogScalingDecimalPoint': reqparam.AnalogScalingDecimalPoint,
        'MaxAnalogDevice': reqparam.MaxAnalogDevice,
        'SlaveID': reqparam.Slvid,
        'Baudrate': reqparam.brate,
        'Parity': reqparam.prty,
        'IntervalTimer': reqparam.intm,
        'APN': reqparam.apn,
        'URL': reqparam.URL,
        'Port': reqparam.port,
        'KeyID': reqparam.kid,
        'Username': reqparam.FTPUsername,
        'CSVName': reqparam.CSVFileName,
        'Password': reqparam.FTPPassword,
        'DLS': reqparam.dls,
        'CNMP': reqparam.cnmp,
        'STRTM': reqparam.strtm,
        'SMSTM': reqparam.smstm,
        'DLM': reqparam.dlm,
        'SMS_M': reqparam.smsmode,
        'Server': reqparam.Server,
        'Resource': reqparam.Resource,
        'GetServer': reqparam.GetServer,
        'GetResource': reqparam.GetResource,
        'PostServer': reqparam.PostServer,
        'PostResource': reqparam.PostResource,
        'GetPortNumber': reqparam.GetPortNumber,
        'PostPortNumber': reqparam.PostPortNumber,
        'DataPostType': reqparam.DataPostType,
        'EthernetHTTPGetCheck': reqparam.EthernetHTTPGetCheck,
        'EthernetHTTPPostCheck': reqparam.EthernetHTTPPostCheck,
        'DataReadType': reqparam.DataReadType,
        'HttpAuth': +reqparam.HttpAuth,
        'WiFiPassword': reqparam.WiFiPassword,
        'WiFiSSID': reqparam.WiFiSSID,
        'HttpUsername': reqparam.HttpAuth == 1 ? reqparam.HttpUsername : '',
        'HttpPassword': reqparam.HttpAuth == 1 ? reqparam.HttpPassword : '',
        'MqttConnectionCheck': reqparam.MqttConnectionCheck,
        'AsciiStringType': reqparam.AsciiStringType,
        'DataPostProtocol': reqparam.DataPostProtocol,
        'SerialDataBits': reqparam.SerialDataBits,
        'HttpDataPostPort': reqparam.HttpDataPostPort,
        'RelayOnTime': reqparam.RelayOnTime,
        'TcpDataPostPort': reqparam.TcpDataPostPort,
        'JDT': reqparam.jdt,
        'EnteredBy': this.UserName,
        'ModifiedBy': this.UserName,
        'TabValue': this.tabName,
        "DirectoryPath": reqparam.DirectoryPath
      };

      // save data in data base
      if (reqparam.DeviceTypeID > 0 || this.DeviceTypeID > 0) {
        this.SaveGSMConfigData();

      }
      else {
        this.successMsg = 'Configuration value Added successfully';
        this.displayMessage1 = this.genericValidator1.processMessages(this.gsmconfigForm, false);
        // this.dialogRef.close(this.GSMConfigFormSaveData);
      }
      this.IsGSMChange = false;
    }
    else {
      return;
    }
  }

  SaveEthernetConfigData() {
    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveEthernetConfigdata(this.EthernetSettingsFormSaveData).subscribe(
      (result) => {
        this.successMsg = 'Configuration value updated successfully';
        this.displayMessage4 = this.genericValidator4.processMessages(this.EthernetSettingsForm, false, this.validationMessages4);
      },
      (error) => {
        this.errorMsg = error;
      });
  }
  OnSubmitEthernetConfig(): void {
    this.EthernetSettingsForm.markAllAsTouched()
    if (this.EthernetSettingsForm.invalid) {
      // this.EthernetSettingsForm.updateValueAndValidity();
      this.displayMessage4 = this.genericValidator4.processMessages(this.EthernetSettingsForm, true, this.validationMessages4);
      return;
    }
    if (this.InTimeMessage === '' && this.SlaveMessage === '' && this.PORTMessage === '' && this.MQTTPORTMessage === '' && this.TimeZoneMessage === '' && this.SlaveValMessage === '') {

      let reqparam = { ...this.EthernetSettingsForm.value };

      this.EthernetSettingsFormSaveData = {
        'DeviceTypeID': reqparam.DeviceTypeID > 0 ? reqparam.DeviceTypeID : this.DeviceTypeID > 0 ? this.DeviceTypeID : 0,
        // 'EnergymeterID': this.MeterId,
        'Ip': reqparam.Ip,
        'Subnet': reqparam.Subnet,
        'Dns': reqparam.Dns,
        'Port': reqparam.Port,
        'Gateway': reqparam.Gateway,
        'IpAddress': reqparam.IpAddress,
        'TcpPort': reqparam.TcpPort
      };
      // save data in data base
      if (reqparam.DeviceTypeID > 0 || this.DeviceTypeID > 0) {
        this.SaveEthernetConfigData();

      }
      else {
        this.successMsg = 'Configuration value Added successfully';
        this.displayMessage4 = this.genericValidator4.processMessages(this.EthernetSettingsForm, false, this.validationMessages4);
        // this.dialogRef.close(this.GSMConfigFormSaveData);
      }
      this.IsEthernetChange = false;
    }
    else {
      return;
    }
  }
  // Call on click Cancel button
  OnCancel() {
    let DeviceProtocolName = this.MqttSettingsForm.value.DeviceProtocolName;
    this.dialogRef.close(DeviceProtocolName);
  }

  // called on close icon
  Close() {

    let DeviceProtocolName = this.MqttSettingsForm.value.DeviceProtocolName;
    let MainConfigData: any;
    MainConfigData = {
      GSMConfigFormSaveData: this.GSMConfigFormSaveData,
      RTCData: this.RTCData1,
      SettingsData: this.SettingsData,
      DeviceProtocolName: DeviceProtocolName,
      EthernetTcpSettingsBO: this.EthernetSettingsFormSaveData,
    }
    this.dialogRef.close(MainConfigData);
  }

  // on Devicetypechange (Master/Slave) show/hide fields
  Ondevice(value): void {
    this.MasterSlave = value;

    if (value == 0) {
      this.gsmconfigForm.controls['Slvid'].setValue(1);
    }
    else {
      this.gsmconfigForm.controls['Maxslav'].setValue('1');
    }
  }
  // call for Getdropdownlist
  Getdropdownlist() {
    let reqpara = 'GSMUnitDeviceType,Baudrate,Parity,APN,DeviceProtocol,DeviceDataLogMode,SmsMode,JSONdatatype,DataLogSelection,DataPostProtocol,DataPostType,AsciiStringType,MqttConnection,DataReadType,HttpAuth,AnalogScalingDecimalPoint,EthernetHTTPGetCheck,EthernetHTTPPostCheck,SerialDataBits';
    this.GSMConfigService.Getdropdownlist(reqpara).subscribe(

      (result) => {
        this.DropDownList = result;
        this.DeviceTypeList = this.DropDownList['listGSMUnitDeviceType'];
        this.ParityList = this.DropDownList['listParity'];
        this.BaudrateList = this.DropDownList['listBaudrate'];
        this.APNList = this.DropDownList['listAPN'];
        this.DeviceProtocolList = this.DropDownList['listDeviceProtocol'];
        this.DataLogList = this.DropDownList['listDatalog'];
        this.SMSModeList = this.DropDownList['listSMSMode'];
        this.JSONdatatypeList = this.DropDownList['listJSONdatatype'];
        this.DataLogSelectionList = this.DropDownList['listDatalogselection'];
        this.DataPostTypeList = this.DropDownList['listDataPostType'];
        this.EthernetHTTPGetCheckList = this.DropDownList['listEthernetHTTPGetCheck'];
        this.EthernetHTTPPostCheckList = this.DropDownList['listEthernetHTTPPostCheck'];
        this.DataReadTypeList = this.DropDownList['listDataReadType'];
        this.AsciiStringTypeList = this.DropDownList['listAsciiStringType'];
        this.MqttConnectionCheckList = this.DropDownList['listMQTTConnection'];
        this.DataPostProtocolList = this.DropDownList['listDataPostProtocol'];
        this.SerialDataBitsList = this.DropDownList['listSerialDataBits'];
        this.HttpAuthList = this.DropDownList['listHttpAuth'];
        this.AnalogScalingDecimalPointList = this.DropDownList['listAnalogScalingDecimalPoint'];

      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // call for GetGSMConfigdata
  GetGSMConfigdata(id) {
    if (id != null && id != 0) {
      this.GSMConfigService.GetGSMConfigdata(id).subscribe(
        (result) => {
          if (result != null) {
            this.DeviceData = result[0];
            // will set data on form
            this.SetConfigFormData();
            this.IsGSMChange = false;
            this.isGSMSaved = true;
          }
          else {
            this.SetConfigFormData();
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  // call for Get RTC data
  GetRTCdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRTCdata(id).subscribe(
        (result) => {
          if (result != null) {
            this.RTCData = result[0];
            // will set data on form
            this.SetRTCData();
            this.IsRTCChange = false;
            this.isRTCSaved = true;
          }
          else {
            this.SetRTCData();
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  GetEthernetdata(id: any) {
    if (id != null) {
      this.GSMConfigService.GetEthernetdata(id).subscribe(
        (result) => {
          if (result != null) {
            this.Ethernetdata = result;
            this.SetEthernetData();
            this.IsEthernetChange = false;
            this.isEthernetSaved = true;
          }
          else {
            this.SetEthernetData();
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  GetMQTTSettingData(id) {
    if (id != null) {
      this.GSMConfigService.GetMQTTSettingData(id).subscribe(
        (result) => {
          if (result !== null) {
            this.MQTData = result[0];
            // will set data on form
            this.SetMQTTSettingData();
          }
          else {
            this.SetMQTTSettingData();
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  blur(): void {
    this.displayMessage1 = this.genericValidator1.processMessages(this.gsmconfigForm);
    this.displayMessage2 = this.genericValidator2.processMessages(this.RTCconfigForm);
    this.displayMessage3 = this.genericValidator3.processMessages(this.MqttSettingsForm);
    this.displayMessage4 = this.genericValidator4.processMessages(this.EthernetSettingsForm);
  }
  // call for SaveGSMConfigData
  SaveGSMConfigData() {

    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveGSMConfigdata(this.GSMConfigFormSaveData).subscribe(
      (result) => {
        this.successMsg = 'Configuration value updated successfully';
        this.displayMessage1 = this.genericValidator1.processMessages(this.gsmconfigForm, false);
      },
      (error) => {
        this.errorMsg = error;
      });
  }
  // RTC page
  GetDatetime() {
    this.RTCconfigForm.patchValue({
      DateTime: this.getdatevar == false ? new Date(this.RTCData.DateTime) : new Date()
    });
    this.getdatevar = true
    this.IsRTCChange = false;
  }
  ResetDevice(val: any) {
    let temp;
    if (val == '101') {
      temp = "RESTART"
    } else if (val == '202') {
      temp = "PARA_UPDATE"
    }
    else if (val == '303') {
      temp = "PTR_RST"
    }
    console.log(temp, 'temp');

    var reqJson = {
      Topic: "12000",
      [temp]: val,
    };
    let gsmreqparam = { ...this.gsmconfigForm.value };

    var reqObj = {
      Topic: gsmreqparam.kid,
      PublishMessageJson: JSON.stringify(reqJson)
    };
    var data = [];
    data.push(reqObj);

    var reqobj = {
      Data: data
    };
    this.SendDatabyMQTT(reqobj);

  }
  // Save RTC Data
  OnSubmitRTC() {

    this.errorMsg = '';
    this.successMsg = '';
    if (this.RTCconfigForm.invalid) {
      this.RTCconfigForm.updateValueAndValidity();
      this.displayMessage2 = this.genericValidator2.processMessages(this.RTCconfigForm, true);
      return;
    }

    this.ValidateFields('TimeZone');
    if (this.TimeZoneMessage === '') {

      let reqparam = { ...this.RTCconfigForm.value };

      this.RTCData1 = {
        DeviceID: reqparam.DeviceID > 0 ? reqparam.DeviceID : this.DeviceTypeID > 0 ? this.DeviceTypeID : 0,
        TimeZone: reqparam.TimeZone,
        DateTime: [formatDate(reqparam.DateTime, 'yyyy-MM-dd HH:mm:ss', 'en')][0],
        TabValue: this.tabName
      };

      if (reqparam.DeviceID > 0 || this.DeviceTypeID > 0) {
        this.SaveRTCData(this.RTCData1);
      }
      else {
        this.successMsg = 'Configuration value Added successfully';
        this.displayMessage2 = this.genericValidator2.processMessages(this.RTCconfigForm, false);
        // this.dialogRef.close(RTCData);
      }
    }
  }

  // Save RTC Data
  SaveRTCData(RTCData) {
    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveRTCSettingData(RTCData).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Values updated successfully';
          this.displayMessage2 = this.genericValidator2.processMessages(this.RTCconfigForm, false);
        }
      },
      (error) => {
        this.errorMsg = error;
      });
  }

  OnSubmitSettings() {
    if (this.MqttSettingsForm.invalid) {
      this.MqttSettingsForm.updateValueAndValidity();
      this.displayMessage3 = this.genericValidator3.processMessages(this.MqttSettingsForm, true);
      return;
    }

    this.ValidateFields('MQTTPORT');

    if (this.MQTTPORTMessage == '') {
      let Mqttsettingsvalue = { ...this.MqttSettingsForm.value };

      this.SettingsData = {
        DeviceID: Mqttsettingsvalue.DeviceID > 0 ? Mqttsettingsvalue.DeviceID : this.DeviceTypeID > 0 ? this.DeviceTypeID : 0,
        DeviceProtocol: Mqttsettingsvalue.protocol,
        ClientName: Mqttsettingsvalue.ClientName,
        Port: Mqttsettingsvalue.port,
        UserName: Mqttsettingsvalue.MqttUsername,
        Password: Mqttsettingsvalue.MqttPassword,
        PublishTopic: Mqttsettingsvalue.MqttPublishtopic,
        PublishDataKey: Mqttsettingsvalue.MqttPublishdatakey,
        TabValue: this.tabName,
        Longitude: Mqttsettingsvalue.Longitude,
        Latitude: Mqttsettingsvalue.Latitude,
        MachineSRNo: Mqttsettingsvalue.MachineSRNo,
      };

      if (Mqttsettingsvalue.DeviceID > 0 || this.DeviceTypeID > 0) {
        this.SaveSettingsData(this.SettingsData);
      }
      else {
        this.successMsg = 'Configuration value Added successfully';
        this.displayMessage3 = this.genericValidator3.processMessages(this.MqttSettingsForm, false);
        // this.dialogRef.close(SettingsData);
      }
    }
    else {
      return;
    }
  }

  // Save Settings Data
  SaveSettingsData(SettingsData) {
    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveMQTTSettingData(SettingsData).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Values updated successfully';
          this.displayMessage3 = this.genericValidator3.processMessages(this.MqttSettingsForm, false);
          this.GetMQTTSettingData(SettingsData.DeviceID);
        }
      },
      (error) => {
        this.errorMsg = error;
      });

  }

  // MQTT senddata function
  SendDatabyMQTT(reqObj) {
    this.errorMsg = '';
    this.successMsg = '';
    this.mqttoperation.PublishdatabyMQTT(reqObj).subscribe(
      (result: any) => {
        if (result == '0') {
          this.successMsg = 'Configuration value submitted successfully';
        }
        else {
          this.errorMsg = 'Submittion Fail,Somthing Went Wrong';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );

  }

  // On Key Press Event
  onKeypressEvent(event, Type) {

    this.ValidateFields(Type);
  }

  // Validation Fields
  ValidateFields(Type) {
    var realValue = '';
    if (Type == 'IntervalTime') {
      realValue = this.gsmconfigForm.value.intm;
      if (+realValue > this.maxInTime || +realValue < this.minInTime) {
        this.InTimeMessage = 'Interval Time should be greater than ' + this.minInTime + ' and less than ' + this.maxInTime;
        return;
      }
      else {
        this.InTimeMessage = '';
      }
    }

    else if (Type == 'PORT' || Type == 'MQTTPORT') {
      if (Type == 'PORT') {
        realValue = this.gsmconfigForm.value.port;
      }
      else {
        realValue = this.MqttSettingsForm.value.port;
      }

      if (+realValue > this.maxPORT || +realValue < this.minPORT) {
        if (Type == 'MQTTPORT') {
          this.MQTTPORTMessage = 'PORT should be greater than ' + this.minPORT + ' and less than ' + this.maxPORT;
        }
        else {
          this.PORTMessage = 'PORT should be greater than ' + this.minPORT + ' and less than ' + this.maxPORT;
        }

        return;
      }
      else {
        this.PORTMessage = '';
      }
    }

    else if (Type == 'TimeZone') {
      realValue = this.RTCconfigForm.value.TimeZone;
      if (+realValue > this.maxTimeZone || +realValue < this.minTimeZone) {
        this.TimeZoneMessage = 'Time Zone should be greater than ' + this.minTimeZone + ' and less than ' + this.maxTimeZone;
        return;
      }
      else {
        this.TimeZoneMessage = '';
      }

    }

    else if (Type == 'SlaveID' && this.MasterSlave === 1) {
      realValue = this.gsmconfigForm.value.Slvid;
      if (+realValue > this.maxSlID || +realValue < this.minSlID) {
        this.SlaveMessage = 'Slave ID should be greater than ' + this.minSlID + ' and less than ' + this.maxSlID;
        return;
      }
      else {
        this.SlaveMessage = '';
      }
    }

    else if (Type == 'Slave' && this.MasterSlave === 0) {
      realValue = this.gsmconfigForm.value.Maxslav;
      if (+realValue > this.maxSlave || +realValue < this.minSlave) {
        this.SlaveValMessage = 'Slave should be greater than or equal to ' + this.minSlave + ' and less than or equal to ' + this.maxSlave;
        return;
      }
      else {
        this.SlaveValMessage = '';
      }
    }
  }

  // Publish GSM Json
  PublishGSMJson() {

    let reqparam = { ...this.gsmconfigForm.value };

    var reqJosn = {
      Topic: '9000',
      MS_SL: reqparam.dtype,
      MAXSLAVE: reqparam.Maxslav,
      SLVID: reqparam.Slvid.toString(),
      BAUD: reqparam.brate,
      PRTY: reqparam.prty,
      INTRTM: reqparam.intm.toString(),
      APN: reqparam.apn,
      DLS: reqparam.dls,
      CNMP: reqparam.cnmp.toString(),
      STRTM: reqparam.strtm.toString(),
      SMSTM: reqparam.smstm.toString(),
      DLM: reqparam.dlm,
      SMS_M: reqparam.smsmode,
      JDT: reqparam.jdt,
      D_READ: reqparam.DataReadType,
      A_TYPE: reqparam.AsciiStringType,
      MQTT_CHECK: reqparam.MqttConnectionCheck,
      DATABITS: reqparam.SerialDataBits,
      RLY_TIME: reqparam.RelayOnTime
    };

    var req2Josn = {
      Topic: '9001',
      A: reqparam.URL, // URL
      B: reqparam.port, // Port
      C: reqparam.kid, // MQTTKeyid
      D: reqparam.FTPUsername,
      E: reqparam.FTPPassword,
      F: reqparam.CSVFileName,
      G: reqparam.DirectoryPath,
      H: reqparam.Server,
      I: reqparam.Resource,
      J: reqparam.DataPostProtocol,
      K: reqparam.DataPostType,
      L: reqparam.HttpDataPostPort,
      M: reqparam.TcpDataPostPort,
      N: reqparam.HttpAuth,
      O: reqparam.HttpUsername,
      P: reqparam.HttpPassword,
      Q: reqparam.WiFiSSID,
      R: reqparam.WiFiPassword
    };
    var reqObj1 = {
      Topic: reqparam.kid,
      PublishMessageJson: JSON.stringify(reqJosn)
    };

    var reqObj2 = {
      Topic: reqparam.kid,
      PublishMessageJson: JSON.stringify(req2Josn)
    };
    var req3Json = {
      Topic: '11000',
      NOCH: reqparam.MaxAnalogDevice,
      SDP: reqparam.AnalogScalingDecimalPoint
    }

    var req4Json = {
      Topic: '11002',
      A: reqparam.PostServer,
      B: reqparam.PostResource,
      C: reqparam.PostPortNumber,
      D: reqparam.EthernetHTTPPostCheck,
    }
    var req5Json = {
      Topic: '11003',
      A: reqparam.GetServer,
      B: reqparam.GetResource,
      C: reqparam.GetPortNumber,
      D: reqparam.EthernetHTTPGetCheck,
    }
    var reqObj3 = {
      Topic: reqparam.kid,
      PublishMessageJson: JSON.stringify(req3Json)
    };
    var reqObj4 = {
      Topic: reqparam.kid,
      PublishMessageJson: JSON.stringify(req4Json)
    };
    var reqObj5 = {
      Topic: reqparam.kid,
      PublishMessageJson: JSON.stringify(req5Json)
    };
    var data = [];
    data.push(reqObj1);
    data.push(reqObj2);
    data.push(reqObj3);
    data.push(reqObj4);
    data.push(reqObj5);
    var reqobj = {
      Data: data
    };
    // send json on mqtt- req1
    this.SendDatabyMQTT(reqobj);

    // this.SendDatabyMQTT(reqObj2);

  }

  PublishEthernetJson() {
    let reqparam = { ...this.EthernetSettingsForm.value };

    var reqJosn = {
      Topic: '11001',
      A: reqparam.Ip,
      B: reqparam.Subnet,
      C: reqparam.Gateway,
      D: reqparam.Dns,
      E: reqparam.Port,
      F: reqparam.IpAddress,
      G: reqparam.TcpPort,
    };
    // let reqparam1 = { ...this.RTCconfigForm.value };

    var reqObj1 = {
      Topic: this.getkid,
      PublishMessageJson: JSON.stringify(reqJosn)
    };



    var data = [];
    data.push(reqObj1);

    var reqobj = {
      Data: data
    };
    // send json on mqtt- req1
    this.SendDatabyMQTT(reqobj);

    // this.SendDatabyMQTT(reqObj2);

  }

  // Publish RTC Json
  PublishRTCJson() {
    // if (this.resetdevice == true)
    // {
    //     var resetreqJosn = {
    //     Topic: '12000',
    //     RESTART:'101',
    // };
    //   }
    // this.ResetDevice()
    let reqparam = { ...this.RTCconfigForm.value };
    let gsmreqparam = { ...this.gsmconfigForm.value };

    var reqJosn = {
      Topic: '10000',
      TIMEZONE: reqparam.TimeZone,
      RTC: [formatDate(reqparam.DateTime, 'dd/MM/yy, HH:mm:ss', 'en')][0]
    };

    var reqObj = {
      Topic: gsmreqparam.kid,// 'IOCL1000000005000097',// reqparam.EnergymeterId,// 'SIPL_RECICLAR/SMIT_1937',
      PublishMessageJson: JSON.stringify(reqJosn)
    };


    var data = [];
    data.push(reqObj);

    var reqobj = {
      Data: data
    };

    // send json on mqtt
    this.SendDatabyMQTT(reqobj);

  }

  // on Tab Changed Event
  onTabChanged(event) {
    this.successMsg = '';
    this.errorMsg = '';
    this.tabName = event.tab.textLabel;

    if (this.tabName == 'RTC') {
      if (this.DeviceTypeID > 0) {
        this.GetRTCdata(this.DeviceTypeID);
      }
      else {
        if (this.RTCData) {
          this.SetRTCData();
          this.IsRTCChange = true;
          this.isRTCSaved = false;
        }
      }
    }
    if (this.tabName == 'Ethernet Settings') {
      if (this.DeviceTypeID > 0) {

        this.GetEthernetdata(this.DeviceTypeID);
      }
      else {
        if (this.Ethernetdata) {
          this.SetEthernetData();
          this.IsEthernetChange = true;
          this.isEthernetSaved = false;
        }
      }
    }
    if (this.tabName == 'Settings') {
      if (this.DeviceTypeID > 0) {
        this.GetMQTTSettingData(this.DeviceTypeID);
      }
      else {
        if (this.MQTData) {
          this.SetMQTTSettingData();
        }
      }
    }
  }
  HttpAuthChange(event: any) {
    if (event.value == 1) {
      this.showvalue = true
    }
    else {
      this.showvalue = false
      // 'HttpUsername': reqparam.HttpAuth == 1 ? reqparam.HttpUsername : '',
      //   'HttpPassword': reqparam.HttpAuth == 1 ? reqparam.HttpPassword : '',

    }
  }
}
